export default "__VITE_ASSET__CJoJcC9k__"